


import CheckIcon from './Check';
import React from 'react';

export interface IconProps {
    size: number;
    color: string;
}

export const EvolunoCheck = ({ size, color }: IconProps) => {
  return (
    <CheckIcon width={size} height={size} color={color} />
  );
};



